import { defineMessages, useIntl } from 'react-intl';
import { useLoginState } from '@packages/shared/src/hooks/useLoginState/useLoginState';
import React, { useEffect } from 'react';
import type { GTMEventGlycerinDisplayWishlist } from '@packages/tracking/src/types/events';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';

const messages = defineMessages({
  emptyWishlistHeadlineLoggedIn: {
    id: 'WishlistEmpty.LoggedIn.Headline',
    defaultMessage: 'Mein Merkzettel',
  },
  emptyWishlistHeadlineLoggedOut: {
    id: 'WishlistEmpty.LoggedOut.Headline',
    defaultMessage: 'Entdecken Sie Ihre Lieblingsartikel',
  },
  emptyWishlistTextLoggedIn: {
    id: 'WishlistEmpty.LoggedIn.InfoText',
    defaultMessage: 'Sie haben keine Artikel auf Ihrem Merkzettel.',
  },
  emptyWishlistTextLoggedOut: {
    id: 'WishlistEmpty.LoggedOut.InfoText',
    defaultMessage: 'Suchen Sie nach Artikeln, die Sie sich bereits gemerkt haben?',
  },
  emptyWishlistAdditionalTextLoggedIn: {
    id: 'WishlistEmpty.LoggedIn.InfoText2',
    defaultMessage: 'Speichern Sie Ihre Lieblingsartikel, um sie nicht aus den Augen zu verlieren.',
  },
  emptyWishlistAdditionalTextLoggedOut: {
    id: 'WishlistEmpty.LoggedOut.InfoText2',
    defaultMessage:
      'Melden Sie sich an, um Ihren Merkzettel zu sehen oder um weitere Artikel auf all Ihren Geräten zu speichern.',
  },
});

export const WishlistEmpty: React.FC = () => {
  const { formatMessage } = useIntl();
  const { loggedIn } = useLoginState();
  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    dispatchGTMEvent<GTMEventGlycerinDisplayWishlist>({
      event: 'DisplayWishList',
      DisplayWishListData: {
        products: [],
      },
      _clear: true,
    });
  }, [dispatchGTMEvent]);

  return (
    <div className="flex flex-col items-center justify-between text-center">
      <div className="icon-emp-wishlist mb-[0.688rem] h-[6.25rem] w-[6.25rem] md:mt-[5rem]" />
      <h3 className="text-size-headline-2xl text-color-text mb-1.5 text-center">
        {formatMessage(
          loggedIn
            ? messages.emptyWishlistHeadlineLoggedIn
            : messages.emptyWishlistHeadlineLoggedOut,
        )}
      </h3>
      <div className="text-size-body-base text-color-text-secondary text-center">
        {formatMessage(
          loggedIn ? messages.emptyWishlistTextLoggedIn : messages.emptyWishlistTextLoggedOut,
        )}
      </div>
      <div className="text-size-body-base text-color-text-secondary mb-4 text-center">
        {formatMessage(
          loggedIn
            ? messages.emptyWishlistAdditionalTextLoggedIn
            : messages.emptyWishlistAdditionalTextLoggedOut,
        )}
      </div>
    </div>
  );
};
